import { useUser } from 'containers/Users';
import { getAuthToken, getCookieUser, getUserCurrentStore } from 'utils/authTyped';
import { AuthService } from 'types/AuthService';

export const useAuth = (): AuthService => {
  const tokens = getAuthToken();
  const cookieUser = getCookieUser();
  const store = getUserCurrentStore();

  const { data: user } = useUser({ userUuid: cookieUser?.uuid, storeUuid: store?.uuid });

  function removeAuthData() {}

  return {
    isAuthenticated: Boolean(tokens?.accessToken && cookieUser && store),
    user: user || null,
    store,
    removeAuthData,
    accessToken: tokens?.accessToken || null,
  };
};
